import {ref, watch, computed} from "@vue/composition-api";
import store from "@/store";
import {title} from "@core/utils/filter";

// Notification
import {useToast} from "vue-toastification/composition";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";

export default function useUsersList() {
  // Use toast
  const toast = useToast();

  const refUserListTable = ref(null);
  let tableColumns = [];
  // Table Handlers

  const perPage = ref(10);
  const totalUsers = ref(0);
  const currentPage = ref(1);
  const perPageOptions = [10, 25, 50, 100];
  const searchQuery = ref("");
  const sortBy = ref("id");
  const isSortDirDesc = ref(true);
  const roleFilter = ref(null);
  const statusFilter = ref(null);
  const itemsCountries = ref([]);
  const itemsStatus = ref([]);
  const itemsType = ref([]);
  const typeFilter = ref(null);

  const dataMeta = computed(() => {
    const localItemsCount = refUserListTable.value
      ? refUserListTable.value.localItems.length
      : 0;
    return {
      from: perPage.value * (currentPage.value - 1) + (localItemsCount ? 1 : 0),
      to: perPage.value * (currentPage.value - 1) + localItemsCount,
      of: totalUsers.value,
    };
  });

  const refetchData = () => {
    refUserListTable.value.refresh();
  };

  watch(
    [currentPage, perPage, searchQuery, roleFilter, statusFilter, typeFilter],
    () => {
      refetchData();
    }
  );

  const parser = JSON.parse(localStorage.getItem("userData"));
  const idOffice = parser.dataUser.officeEmployee_officeId;
  const idRol = ref(parser.userData.rolId);
  if (idRol.value == 3) {
    tableColumns = [
      {key: "name", sortable: true},
      {key: "type.name", label: "Type", sortable: true},
      {key: "status", sortable: true},
      {key: "actions"},
    ];
  } else {
    tableColumns = [
      {
        key: "officeCategory[0].cloverId",
        label: "POS ID",
        sortable: true,
      },
      {key: "name", sortable: true},
      {key: "type.name", label: "Type", sortable: true},
      {key: "status", sortable: true},
      {key: "actions"},
    ];
  }

  const fetchUsers = (ctx, callback) => {
    store
      .dispatch("app-user/fetchUsers", {
        q: searchQuery.value.toLowerCase(),
        perPage: perPage.value,
        page: currentPage.value,
        sortBy: sortBy.value,
        sortDesc: isSortDirDesc.value,
        name: roleFilter.value,
        status: statusFilter.value,
        type: typeFilter.value,
        idOffice,
        idRol,
      })
      .then((response) => {
        const {data, total} = response.data;
        callback(data);
        totalUsers.value = total;
        const arrayCountry = [];
        const arrayData = [];
        const setObj = new Set();

        const arrayDataType = [];
        const setObjType = new Set();

        data.map((data, item) => {
          arrayCountry.push({label: data.name, value: data.name});
          if (!setObj.has(data.status)) {
            setObj.add(data.status, data);
            arrayData.push({
              label: data.status === true ? "Active" : "Inactive",
              value: data.status,
              id: data.status,
            });
          }

          ///Type

          if (!setObjType.has(data.type.name)) {
            setObjType.add(data.type.name, data);
            arrayDataType.push({
              label: data.type.name,
              value: data.type.name,
              id: item,
            });
          }
        });
        itemsCountries.value = arrayCountry;

        console.log("arrayData", arrayData);
        itemsStatus.value = arrayData;
        itemsType.value = arrayDataType;
      })
      .catch(() => {
        toast({
          component: ToastificationContent,
          props: {
            title: "Error fetching country list",
            icon: "AlertTriangleIcon",
            variant: "danger",
          },
        });
      });
  };

  // *===============================================---*
  // *--------- UI ---------------------------------------*
  // *===============================================---*

  const resolveUserRoleVariant = (role) => {
    if (role === "subscriber") return "primary";
    if (role === "author") return "warning";
    if (role === "maintainer") return "success";
    if (role === "editor") return "info";
    if (role === "admin") return "danger";
    return "primary";
  };

  const resolveUserRoleIcon = (role) => {
    if (role === "subscriber") return "UserIcon";
    if (role === "author") return "SettingsIcon";
    if (role === "maintainer") return "DatabaseIcon";
    if (role === "editor") return "Edit2Icon";
    if (role === "admin") return "ServerIcon";
    return "UserIcon";
  };

  const resolveUserStatusVariant = (status) => {
    if (status === true) return "success";
    if (status === false) return "warning";
    return "success";
  };

  const dataItemCountries = itemsCountries;
  const dataItemStatus = itemsStatus;
  const dataItemType = itemsType;

  return {
    fetchUsers,
    tableColumns,
    perPage,
    currentPage,
    totalUsers,
    dataMeta,
    perPageOptions,
    searchQuery,
    sortBy,
    isSortDirDesc,
    refUserListTable,
    idRol,

    resolveUserRoleVariant,
    resolveUserRoleIcon,
    resolveUserStatusVariant,
    refetchData,

    // Extra Filters
    roleFilter,
    statusFilter,
    dataItemStatus,
    dataItemCountries,
    dataItemType,
    typeFilter,
  };
}
